/*
 * Directions links ask which map app to open: Apple Maps or Google Maps.
 * Phone feedback 10.2026: Apple devices do not come with Google Maps.
 * Any link to the store address on a map site is caught here, so new links need no extra markup.
 */
(function () {
  var ADDRESS = '87B Carleton Ave, Islip Terrace, NY 11752';
  var MAP_LINK = /^https?:\/\/(maps\.google\.com|www\.google\.com\/maps|google\.com\/maps|maps\.app\.goo\.gl|goo\.gl\/maps)/i;
  var root = null;
  var lastFocus = null;

  function build() {
    if (root) return root;
    root = document.createElement('div');
    root.className = 'ri-maps';
    root.hidden = true;
    root.innerHTML =
      '<button type="button" class="ri-maps__scrim" data-ri-maps-close aria-label="Close"></button>' +
      '<div class="ri-maps__sheet" role="dialog" aria-modal="true" aria-labelledby="RiMapsTitle" tabindex="-1">' +
        '<p class="ri-maps__title" id="RiMapsTitle">Open directions in</p>' +
        '<p class="ri-maps__address">' + ADDRESS + '</p>' +
        '<a class="ri-maps__choice" data-ri-maps-apple target="_blank" rel="noopener">Apple Maps</a>' +
        '<a class="ri-maps__choice" data-ri-maps-google target="_blank" rel="noopener">Google Maps</a>' +
        '<button type="button" class="ri-maps__cancel" data-ri-maps-close>Cancel</button>' +
      '</div>';
    document.body.appendChild(root);
    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-ri-maps-close]')) close();
      else if (event.target.closest('.ri-maps__choice')) window.setTimeout(close, 0);
    });
    return root;
  }

  function open(googleUrl) {
    build();
    root.querySelector('[data-ri-maps-google]').href = googleUrl;
    root.querySelector('[data-ri-maps-apple]').href =
      'https://maps.apple.com/?daddr=' + encodeURIComponent(ADDRESS);
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('ri-maps-open');
    var sheet = root.querySelector('.ri-maps__sheet');
    if (sheet) sheet.focus();
  }

  function close() {
    if (!root || root.hidden) return;
    root.hidden = true;
    document.documentElement.classList.remove('ri-maps-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || link.closest('.ri-maps')) return;
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey) return;
    var href = link.getAttribute('href') || '';
    if (!MAP_LINK.test(href)) return;
    event.preventDefault();
    open(href);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
  });
})();
